export const getReviewsForGalleryQuery = `
query GetReviewsForGalleryByStorefrontId(
  $id: ID!
  $size: Int
  $page: Int
) {
  reviews(
    input: {
      pagination: { page: $page, size: $size }
      filters: { storefrontId: $id, disputed: false, photos: true }
      orderBy: { type: date, sort: desc }
    }
  ) {
    nodes {
      id
      overallRating
      createdAt
      content
      reviewer {
        firstName
        lastName
      }
      photos {
        active
        sourceId
        createdAt
        updatedAt
        name
        width
        height
      }
    }
  }
  summaryReviews(input: { storefrontId: $id}) {
    gallery {
      photoCount
    }
  }
}
	`;

export type ReviewsForGallery = {
	reviews: PaginatedReview;
	summaryReviews: SummaryReviews;
};

type PaginatedReview = {
	nodes: ReviewNode[];
};

export type ReviewNode = {
	content: string;
	createdAt: string;
	id: string;
	overallRating: number | null;
	photos: ReviewPhoto[];
	reviewer: Reviewer;
};

export type ReviewPhoto = {
	active: boolean;
	createdAt: string;
	height: number | null;
	name: string | null;
	sourceId: string | null;
	updatedAt: string;
	width: number | null;
};

type Reviewer = {
	firstName: string | null;
	lastName: string | null;
};

export type SummaryReviews = {
	gallery: {
		photoCount: number;
	};
};
